import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
//UI
import { Card, Segment, Image, Table, Header, Divider, Icon, Form, Accordion, Loader, Message, Grid } from "semantic-ui-react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { Collapse } from "@material-ui/core";
//ACTIONS
import { fetchCruiseLogs } from "../../../../redux/actions/reservations/cruise/fetchCruiseLogs";
import { updateCruiseNote } from "../../../../redux/actions/reservations/cruise/updateCruiseNote";
import { fetchOrderService, initialStateOrderService, } from "../../../../redux/actions/reservations/orderService/fetchOrderService";
import { fetchPassengersZarpe, initialStatePassengerZarpe, } from "../../../../redux/actions/reservations/passenger/fetchPassengersZarpe";
import { fetchCruiseDetailsCustom, initialStateCruiseDetailsCustom } from "../../../../redux/slices/custom/reservations/cruise/cruiseDetails/customCruiseDetails.slice";
//RESOURCES
import CruiseTableResumenDivided from "../../../../components/cruise/cruiseTableResumenDivided";
import CruiseTableResumenNotDivided from "../../../../components/cruise/cruiseTableResumenNotDivided";
import CruiseTableSalesReport from "../../../../components/cruise/cruiseTableSalesReport";
import orderServicePDF from "../../orderService/OrderServicePDF";
import generateZarpeReport from "../zarpe/zarpePDF";
import rwittmerLogo from "../../../../containers/icons/logo_rwittmer.png";
import LogsHistory from "../../../../components/reservation/logsHistory";
import single_bed from "../../../icons/single_bed.png";
import double_bed from "../../../icons/double_bed.png";
import bunk from "../../../icons/bunk.png";
import "../../../styles/common.css";
import GenderIcon from "../../../../components/reservation/genderIcon";
import CruisePassengerNationality from '../../../../components/cruise/cruisePassengerNationality';
import { scrollToTop } from "../../../resources/utils";
import CruiseActionsMenu from "./components/CruiseActionsMenu";

export default function CruiseDetailList() {
  let history = useHistory();
  let { cruise_id } = useParams();
  const { t } = useTranslation();
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const { register, errors, handleSubmit } = useForm();
  const [openHistory, setOpenHistory] = useState(false);
  const [cruiseType, setCruiseType] = useState("");
  const customCruiseState = useSelector(state => state.customCruiseDetails);
  const cruiseState = useSelector(state => state.cruiseReducer);
  const cruiseLogState = useSelector((state) => state.cruiseLogReducer);
  const orderServiceState = useSelector((state) => state.orderServiceReducer);
  const passengersZarpeState = useSelector((state) => state.passengerZarpeReducer);
  const user = JSON.parse(localStorage.getItem("userInfo"));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCruiseDetailsCustom(cruise_id));
    scrollToTop();
    return () => {
      dispatch(initialStateCruiseDetailsCustom());
    };
  }, [dispatch, cruise_id]);

  if (customCruiseState.fetching || cruiseState.fetching) {
    return <CircularProgress />;
  }

  const handleReservation = () => {
    history.push(`/cruises/${cruise_id}/reservations`);
  };
  const handleEdit = () => {
    history.push(`/cruises/${cruise_id}`);
  };
  const handlePassengers = () => {
    history.push(`/cruises/${cruise_id}/passengers`);
  };

  const handleIngala = () => {
    history.push(`/cruises/${cruise_id}/ingalaReport`);
  };

  const handleGpsTax = () => {
    history.push(`/cruises/${cruise_id}/gpsTaxReport`);
  };

  const handleOrderService = () => {
    dispatch(fetchOrderService(cruise_id));
  };

  const handleVoucher = () => {
    history.push(`/cruises/${cruise_id}/vouchers`);
  };

  const handleFlights = () => {
    history.push(`/cruises/${cruise_id}/flightListPassengersReport`);
  };

  const onSubmit = (data) => {
    dispatch(updateCruiseNote(cruise_id, data));
  };

  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });

    setTimeout(() => {
      setState({ ...state, open: false });
    }, 4000);
  };

  const handleGetPassengersTotal = () => {
    dispatch(fetchPassengersZarpe(cruise_id));
  };

  let filterPassengers = async (passengers, cruiseType) => {
    if (cruiseType === "TO") {
      return await passengers.filter(
        (passenger) => passenger.cruise_type === "TO"
      );
    } else if (cruiseType === "PP") {
      return await passengers.filter(
        (passenger) => passenger.cruise_type !== "SP"
      );
    } else if (cruiseType === "SP") {
      return await passengers.filter(
        (passenger) => passenger.cruise_type !== "PP"
      );
    }
  };

  if (orderServiceState.message === "Order service send successfully") {
    orderServicePDF(orderServiceState.orderService, t);
    dispatch(initialStateOrderService());
  }

  if (passengersZarpeState.message === "resource found succesfully") {
    filterPassengers(passengersZarpeState.passengers, cruiseType).then(
      (value) => {
        generateZarpeReport(value, customCruiseState.cruise);
        dispatch(initialStatePassengerZarpe());
      }
    );
  }

  const handleHistoyClick = () => {
    setOpenHistory(!openHistory);
    if (!openHistory) {
      dispatch(fetchCruiseLogs(cruise_id));
    }
  };

  return (
    <>
      {cruiseState.error ? (
        <Message negative content={t(cruiseState.error)} />
      ) : (
        ""
      )}
      {cruiseState.message === "notes updated successfully" ? (
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
        >
          <Alert severity="success" color="success" variant="filled">
            {t("cruise_detail_upadate")}
          </Alert>
        </Snackbar>
      ) : (
        ""
      )}
      <div className="ui breadcrumb">
        <Link to="/" className="section">
          {t("cruise_tiptop")}
        </Link>
        <div className="divider">/</div>

        <div className="active section">{customCruiseState.cruise.code}</div>
      </div>
      <br></br>
      <br></br>
      <CruiseActionsMenu
        t={t}
        user={user}
        handleReservation={handleReservation}
        handleEdit={handleEdit}
        handlePassengers={handlePassengers}
        handleIngala={handleIngala}
        handleGpsTax={handleGpsTax}
        handleOrderService={handleOrderService}
        handleVoucher={handleVoucher}
        handleFlights={handleFlights}
        handleGetPassengersTotal={handleGetPassengersTotal}
        setCruiseType={setCruiseType}
        orderServiceState={orderServiceState}
        passengersZarpeState={passengersZarpeState}
      />
      <h4 className="lg:mt-24">{t("general_information_tag")}</h4>
      <Divider variant="middle" />
      <Grid stackable>
        <Grid.Row stretched>
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={5}
          >
            <Card fluid className="card_header_style">
              <Card.Content>
                <Table basic="very">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <span
                          style={{
                            color: "#2185D0",
                            fontSize: "22px",
                            fontWeight: "800",
                          }}
                        >
                          {customCruiseState.cruise.code}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        <span className="header_style">
                          {customCruiseState.yacht.name}
                        </span>
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_name")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>{customCruiseState.cruise.name}</Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_itinerary")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>{customCruiseState.itinerary.name}</Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_startDate")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>
                        {customCruiseState.cruise.start_date_format}
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_endDate")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>
                        {customCruiseState.cruise.end_date_format}
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_languages")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>
                        {
                          user.role === 'admin'|| user.role === 'admin_assistant' ?
                            <Link
                              to={`/cruises/${cruise_id}/languages`}
                            >
                              {customCruiseState.cruiseLanguages?.map(
                                (cruiseLanguageItem) =>
                                  cruiseLanguageItem.languages.length > 0
                                    ? cruiseLanguageItem.languages
                                      .map((language) => language.language_name)
                                      .join(" / ")
                                    : t("cruise_detail_notAssigned")
                              )}
                            </Link>
                            :
                            <>
                              {
                                customCruiseState.cruiseLanguages?.map(
                                  (cruiseLanguageItem) =>
                                    cruiseLanguageItem.languages.length > 0
                                      ? cruiseLanguageItem.languages
                                        .map((language) => language.language_name)
                                        .join(" / ")
                                      : t("cruise_detail_notAssigned")
                                )
                              }
                            </>
                        }
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Card.Content>
            </Card>
          </Grid.Column>

          <Grid.Column
            mobile={16}
            tablet={8}
            computer={5}
          >
            <Card fluid className="card_header_style">
              <Card.Content>
                <Table basic="very" unstackable>
                  <Table.Body>
                    {customCruiseState.guidesOnBoard?.map((guideOnBoardItem) =>
                      guideOnBoardItem.guides.length === 0 ?

                        < Table.Row >
                          <Table.Cell>
                            <Header>
                              <span className="header_style">
                                {t("cruise_detail_guide")}
                              </span>
                            </Header>
                          </Table.Cell>
                          <Table.Cell>
                            {
                              user.role === 'admin'|| user.role === 'admin_assistant' ?
                                <Link
                                  to={`/cruises/${cruise_id}/guides`}
                                >
                                  {t("cruise_detail_notAssigned")}
                                </Link>

                                : t("cruise_detail_notAssigned")
                            }

                          </Table.Cell>
                        </Table.Row>
                        :
                        guideOnBoardItem.guides.map((guide, index) => (
                          <Table.Row key={guide.id}>
                            <Table.Cell>
                              <Header>
                                <span className="header_style">
                                  {t("cruise_detail_guide")}{guide.order}
                                </span>
                              </Header>
                            </Table.Cell>
                            <Table.Cell>
                              {
                                user.role === 'admin'|| user.role === 'admin_assistant'?
                                  <Link
                                    to={`/cruises/${cruise_id}/guides`}
                                  >{guide.first_name} {guide.last_name}
                                  </Link>
                                  :
                                  <> {guide.first_name} {guide.last_name} </>
                              }
                            </Table.Cell>
                            <Table.Cell>{guide.language_name}</Table.Cell>
                            <Table.Cell>
                              {t("cruise_detail_identification")}:{" "}
                              {guide.document_number
                                ? guide.document_number
                                : t("cruise_detail_notAssigned")}
                            </Table.Cell>
                          </Table.Row>
                        ))
                    )}
                    <Table.Row>
                      <Table.Cell>
                        <Header>
                          <span className="header_style">
                            {t("cruise_detail_captain")}
                          </span>
                        </Header>
                      </Table.Cell>
                      <Table.Cell>
                        {
                          user.role === 'admin' || user.role === 'admin_assistant' ?
                            <Link
                              to={`/cruises/${cruise_id}`}
                            >
                              {customCruiseState.captain.first_name}{" "}
                              {customCruiseState.captain.last_name}
                            </Link>
                            :
                            <>
                              {customCruiseState.captain.first_name}{" "}
                              {customCruiseState.captain.last_name}
                            </>
                        }
                      </Table.Cell>
                    </Table.Row>

                  </Table.Body>
                </Table>
              </Card.Content>
            </Card>
          </Grid.Column>

          <Grid.Column
            mobile={16}
            tablet={8}
            computer={6}

          >
            <Card fluid className="card_header_style">
              <Card.Content>

                <Table unstackable>
                  <Table.Header>
                    <Table.Row textAlign="center">
                      <Table.HeaderCell></Table.HeaderCell>
                      <Table.HeaderCell style={{ backgroundColor: "#DBADFF" }}>
                        {t("cruise_detail_available")}
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        {t("cruise_detail_reserved")}
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        {t("cruise_detail_confirmed")}
                      </Table.HeaderCell>
                      <Table.HeaderCell>
                        {t("cruise_detail_wait")}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  {customCruiseState.cruise.transfer_day === 0 ? (
                    <CruiseTableResumenNotDivided
                      TO={customCruiseState.cruise.TO}
                      numberSpacesUsed_TO_Confirmed={customCruiseState.cruise.numberSpacesUsed_TO_Confirmed}
                      numberSpacesUsed_TO_Reserved={customCruiseState.cruise.numberSpacesUsed_TO_Reserved}
                      numberSpacesUsed_TO_Waiting={customCruiseState.cruise.numberSpacesUsed_TO_Waiting}
                    />
                  ) : (
                    <CruiseTableResumenDivided
                      {...customCruiseState.cruise}
                    />
                  )}
                </Table>

                <Divider />

                <Table unstackable>
                  <Table.Header>
                    <Table.Row textAlign="center">
                      <Table.HeaderCell>Sales Report</Table.HeaderCell>
                      <Table.HeaderCell>120 {t("cruise_detail_days")}</Table.HeaderCell>
                      <Table.HeaderCell>90 {t("cruise_detail_days")}</Table.HeaderCell>
                      <Table.HeaderCell>60 {t("cruise_detail_days")}</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  {customCruiseState.reservations?.map((reservation, index) =>
                    reservation.charter === 1 ? (
                      <CruiseTableSalesReport
                        key={index}
                        {...reservation}
                      />
                    ) : null
                  )}
                </Table>
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <h4> {t("cruise_detail_notes")}</h4>
      <Divider variant="middle" />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <textarea
          placeholder={t("cruise_detail_notes")}
          name="notes"
          autoFocus
          defaultValue={customCruiseState.cruise.notes}
          rows="3"
          ref={register()}
        ></textarea>
        <br></br>
        <br></br>
        <button
          type="submit"
          onClick={handleClick({ vertical: "top", horizontal: "right" })}
          className={
            customCruiseState.processing
              ? "ui loading primary button"
              : "ui primary button"
          }
        >
          {t("update_notes")}
        </button>
      </Form>
      <h4>{t("cruise_detail_cabins")}</h4>
      <Divider variant="middle" />
      <Card.Group itemsPerRow={2} stackable>
        {customCruiseState.cabins.map((cabin, index) => (
          <Card key={index}>
            <Card.Header className="cruise_header">
              <div className="bed_display">
                <Segment inverted color="blue" className="cruise_name h-8 flex items-center justify-center">
                  <span>{cabin.cabin}</span>
                </Segment>
                <div className="bed_display">
                  {cabin.berths?.map((cabin_icon, index) => (
                    <span key={index}>
                      {cabin_icon === "single_bed.png" ? (
                        <Image src={single_bed} className="bed_image" />
                      ) : cabin_icon === "double_bed.png" ? (
                        <Image src={double_bed} className="bed_image" />
                      ) : cabin_icon === "bunk.png" ? (
                        <Image src={bunk} className="bed_image" />
                      ) : (
                        ""
                      )}
                    </span>
                  ))}
                </div>
              </div>
              {cabin.bookings.length == 0 && (
                <div className="flex flex-col items-center gap-0">
                  <p className="text-[13px]">{t("cruise_detail_cabin_available")}</p>
                  <Image src={rwittmerLogo} alt="rwittmerLogo" style={{ width: "160px", height: "80px" }} className=" object-contain" />
                </div>
              )}
              <div className="cruise_deck">
                <span className="cruise_text">{cabin.deck}</span>
              </div>
            </Card.Header>
            {cabin.bookings.length > 0 && (
              <Card.Content>
                {Object.entries(
                  cabin.bookings.reduce((groups, booking) => {
                    const type = booking.cruise_type || 'Sin tipo';
                    if (!groups[type]) groups[type] = [];
                    groups[type].push(booking);
                    return groups;
                  }, {})
                ).map(([type, bookings]) => (
                  <div key={type} className="mb-4">
                    <Card.Group
                      stackable
                      itemsPerRow={4}
                      className="flex justify-center items-center p-2 gap-2"
                    >
                      {bookings.map((booking, index) => (
                        <Card key={index} style={{ width: '43%' }}>
                          <Card.Header className="flex justify-between items-center py-1 px-2">
                            <span
                              className={`text-[13px] lowercase px-2 rounded-lg border 
                    ${booking.state === 'confirmed'
                                  ? 'bg-green-600/40 border-green-500 text-green-700'
                                  : booking.state === 'reserved'
                                    ? 'bg-blue-600/40 border-blue-500 text-blue-700'
                                    : 'bg-yellow-600/40 border-yellow-500'
                                }`}
                            >
                              {t(booking.state)}
                            </span>
                            <p className="font-semibold text-[15px]">{booking.cruise_type}</p>
                          </Card.Header>

                          <Card.Content textAlign="center">
                            {booking.name ? (
                              <Link
                                to={`/cruises/${cruise_id}/reservations/${booking.reservation_id}/bookings/${booking.booking_id}/spaces/${booking.space_id}/spacePassenger/${booking.space_passenger_id}/passengers/${booking.passenger_id}`}
                              >
                                <p className="truncate max-w-[100ch] text-[15px] font-semibold">
                                  {booking.name}
                                </p>
                              </Link>
                            ) : (
                              <span>
                                <Icon name="question circle" size="big" />
                                <br />
                                <span>{t('cruise_detail_notAssigned')}</span>
                              </span>
                            )}
                            <p className="truncate max-w-[100ch]">{booking.agencyName}</p>
                          </Card.Content>

                          {booking.genderName && (
                            <div className="p-2 flex items-center justify-between">
                              <GenderIcon gender={booking.genderName} />
                              <CruisePassengerNationality item={booking} />
                            </div>
                          )}
                        </Card>
                      ))}
                    </Card.Group>
                  </div>
                ))}
              </Card.Content>
            )}
          </Card>
        ))}
      </Card.Group >
      <br />
      <Accordion styled style={{ width: "100vw" }}>
        <Accordion.Title onClick={handleHistoyClick} style={{ display: "flex", gap: "5px" }}>
          {t("log_historical")}
          {openHistory ? <ExpandLess /> : <ExpandMore />}
        </Accordion.Title>
        {cruiseLogState.fetching ? (
          <div style={{ display: "flex", width: "100vw", height: "80px", justifyContent: "center" }}>
            <Loader size="medium" active inline>Loading...</Loader>
          </div>
        ) : (
          <Collapse in={openHistory} timeout="auto" unmountOnExit style={{ padding: "15px" }}>
            <LogsHistory
              logsHistory={cruiseLogState.logs}
            />
          </Collapse>
        )}
      </Accordion>
    </>
  );
}
